import { render, staticRenderFns } from "./Sepa.vue?vue&type=template&id=39f863d4&"
import script from "./Sepa.vue?vue&type=script&lang=js&"
export * from "./Sepa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports